import { Http, Response, Headers } from '@angular/http';
import { Injectable, Inject, Injector } from '@angular/core';

import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import {Token} from './token';

@Injectable()
export class AuthenticationService {
    
    private subject = new BehaviorSubject(null);
    private group = new BehaviorSubject(null);
    private userInfo: any;
    
    constructor() {
        if (this.isTokenValid()) {
            this.subject.next(this.getToken().userName);
            this.group.next(this.getToken().clientName);
        }
    }

    setUserInfo(userInfo: any) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        this.userInfo = userInfo;
    }

    isSysAdmin(): boolean {
        if (this.userInfo==null) {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (this.userInfo==null) {
                //this.logout();
                return false;
            }
        }
        for (let role of this.userInfo.roles) {
            if (role==="SYSADMIN") {
                return true;
            }
        }
        return false;
    }

    getHeaderByToken(token: any) : Headers {
        var headers = new Headers();
        headers.append('X-Authorization', token.value);
        return headers;
    }

    getHeaderJsonByToken(token: any) : Headers {
        var headers = new Headers();
        headers.append('X-Authorization', token);
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        return headers;
    }
    
    getHeader() : Headers {
        var headers = new Headers();
        headers.append('X-Authorization', this.getToken().value);
        return headers;
    }

    getHeaderPDF() : Headers {
        var headers = new Headers();
        headers.append('X-Authorization', this.getToken().value);
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/pdf');
        return headers;
    }

    getHeaderOctetByToken(token: any) : Headers {
        var headers = new Headers();
        headers.append('X-Authorization', token);
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/octet-stream');
        return headers;
    }
    
    getUserName(): Observable<any> {
        return this.subject.asObservable();
    }
    
    getGroupName(): Observable<any> {
        return this.group.asObservable();
    }

    setToken(token: Token) {
        localStorage.setItem('currentToken', JSON.stringify(token));
        this.subject.next(token.userName);
        this.group.next(token.clientName);
    }

    setStorageName(storageName: string) {
        localStorage.setItem('storageName', storageName);
    }

    getStorageName() : string {
        return localStorage.getItem('storageName');
    }
    
    isTokenValid() : boolean {
        let token : Token;
        token = this.getToken();
        if (token!=null) {
            let dateString = token.validUntil.toString().split(/[-T.]/);
            let checkDate = new Date( dateString.slice(0,3).join('/')+' '+dateString[3] );
            if (token.value!=null && token.validUntil!=null) {
                if (checkDate.valueOf() >= Date.now().valueOf() ) {
                    return true;
                }
            }
        }
        return false;
    }
    
    getToken() : Token {
        return JSON.parse(localStorage.getItem('currentToken'));
    }
    
    logout() {
        this.subject.next(null);
        // remove user from local storage to log user out
        localStorage.removeItem('currentToken');
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/services/security/authentication.service.ts